






import {Component, Vue} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {AUTH_GET_CLIENT, AUTH_GET_COUNTRY} from '@/store/modules/authentication/types';
import {Client} from '@/store/modules/authentication/interfaces';
import {TupleDictionary} from '@/utils/tupleDictionary';
import {ClientEnum} from '@/enums/client.enum';
import {CountryEnum, CountryType} from '@/enums/country.enum';
import ReportPowerBiContainer from '@/modules/neodash/components/report-powerbi-container/report-powerbi-container.vue';
import {traceLogAccess} from '@/services';
import {ContextEnum} from '@/enums/context.enum';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from '@/modules/neodash/containers/powerbi/pbi-dict-workspace-id';

@Component({
  name: 'PbiRecallMonitor',
  components: { ReportPowerBiContainer }
})
export default class PbiRecallMonitorPage extends Vue {
  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  @Getter(AUTH_GET_COUNTRY)
  public country: CountryType;

  private pbiDictWorkspaceId = new PbiDictWorkspaceId();
  public dictReports = new TupleDictionary<[ClientEnum, CountryType], IPbiContainer>();
  public crrReport: IPbiContainer = { brand: '', workspaceId: '', reportId: '' };

  mounted() {
    this.dictReports.set([ClientEnum.Honda, CountryEnum.Brasil], { brand: 'Honda', workspaceId: 'cbb2f0e1-7be5-4864-8eb2-b89d1a322fc5 ', reportId: '5d24f960-5428-4ecb-a1e5-5dd8e43c390c' });

    this.crrReport = this.dictReports.get([this.client.id, this.country]);
    traceLogAccess.logAction(ContextEnum.Report, `${this.crrReport.brand} - Recall Monitor`);
  }
}
